const DenmarkSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111294)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.6524 17.3913H39.8309C38.5525 7.57828 30.1616 0 20.0002 0C18.5068 0 17.0523 0.165078 15.6523 0.475391V17.3913H15.6524Z"
        fill="#D80027"
      />
      <path
        d="M10.4349 17.3921V2.43262C4.94326 5.42902 1.01186 10.9252 0.169434 17.3921H10.4349V17.3921Z"
        fill="#D80027"
      />
      <path
        d="M10.4348 22.6084H0.169434C1.01186 29.0754 4.94326 34.5715 10.4349 37.5679L10.4348 22.6084Z"
        fill="#D80027"
      />
      <path
        d="M15.6523 22.6085V39.5243C17.0523 39.8347 18.5068 39.9997 20.0002 39.9997C30.1616 39.9997 38.5525 32.4214 39.8309 22.6084H15.6523V22.6085Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111294">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DenmarkSvg;
